/* eslint-disable-next-line @nx/enforce-module-boundaries */
import { FEATURE_FLAGS, FLAG_TYPE } from '@marriott/mi-feature-flag-utils';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

export const useLogoAutomation: () => FLAG_TYPE = () => {
  const featureFlags = useClientEnvVarsStore(state => state.envVarsObject.featureFlags) as unknown as Record<
    string,
    FLAG_TYPE
  >;
  return featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION] ?? false;
};
